import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  setActiveTest
} from '../../actions/client';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import s from './Tests.css';

class Tests extends PureComponent {

  selectTest(name) {
    this.props.setActiveTest(name);
  }

  checkIfCompleted(name) {
    const completed = this.props.testData.results.filter((result) => result.name === name);
    return completed.length > 0 ? true : false;
  }

  render() {
    const {
      testData
    } = this.props;
    const nfCompleted = this.checkIfCompleted(NF_TEST);
    const rrCompleted = this.checkIfCompleted(RR_TEST);
    const laCompleted = this.checkIfCompleted(LA_TEST);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className={s.headerRow}></div>
            <div className={s.headerTitle}>Please choose a Behavioral Finance Test</div>
          </div>
        </div>
        <div className="row">
          { testData.tests.includes(NF_TEST) &&
            <div className="col-md-4">
              <div className={s.testTitle}>Big Picture Assessment</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                  This test will take a couple of minutes to complete. It is designed to reveal
                  important aspects of your financial decision-making style.
                </div>
                { nfCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(NF_TEST)}>RETAKE</button>
                }
                { !nfCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(NF_TEST)}>START</button>
                }
              </div>
            </div>
          }
          { testData.tests.includes(RR_TEST) &&
            <div className="col-md-4">
              <div className={s.testTitle}>Retirement Regret</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                  This survey can help you determine whether you are likely to regret the
                  timing of your retirement. In particular, it can identify whether you
                  are at risk of retiring too early, a financial mistake with serious consequences.
                  <br /><br />
                  The survey consists of six questions and takes a couple of minutes to complete.
                </div>
                <div style={{width:'100%',textAlign:'center'}}>
                { rrCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(RR_TEST)}>RETAKE</button>
                }
                { !rrCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(RR_TEST)}>START</button>
                }
                </div>
              </div>
            </div>
          }
          { testData.tests.includes(LA_TEST) &&
            <div className="col-md-4">
              <div className={s.testTitle}>Loss Aversion</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                  On each of the following 10 pages, you will see a pair of gambles.
                  Each gamble has three equally likely outcomes.
                  <br /><br />
                  For each page, please choose which gamble you prefer.
                </div>
                { laCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(LA_TEST)}>RETAKE</button>
                }
                { !laCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(LA_TEST)}>START</button>
                }
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    testData: state.clientData.testData,
  };
}

export default connect(mapStateToProps,{
  setActiveTest,
})(Tests);



// WEBPACK FOOTER //
// ./src/components/ClientMode/Tests.js